/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Create
**********************************************************/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { packageForm } from './irrigation_utils';
import { prepareData, handleValveHours, handleEngineHours, 
  handleMeterGallons, createIrrigation, preloadMeterForm } from './irrigation_actions';
import IrrigationForm from './components/irrigation_form';
import FooterModal from './components/footer_modal';
import IrrigationDisplay from './components/irrigation_display';

const propTypes = {
  employees: PropTypes.array,
  engines: PropTypes.array,
  meters: PropTypes.array,
  valves: PropTypes.array,
  user: PropTypes.object,
  handleEngineHours: PropTypes.func,
  handleValveHours: PropTypes.func,
  handleMeterGallons: PropTypes.func,
  createIrrigation: PropTypes.func,
  preloadMeterForm: PropTypes.func,
  prepareData: PropTypes.func
};

class IrrigationCreate extends Component {
  componentDidMount() {
    if (this.props.meters.length > 0) this.props.preloadMeterForm({ prevMeters: this.props.prevMeters, formId: 'meter-form' });
  }
  render() {
    return (
      <div>
        <div className="row">
          <IrrigationForm formId={'irrigation-form'} employees={this.props.employees} engines={this.props.engines} meters={this.props.meters}
            valves={this.props.valves} handleEngineHours={this.props.handleEngineHours} handleMeterGallons={this.props.handleMeterGallons} 
            handleValveHours={this.props.handleValveHours} />
        </div>
        <div className="row">
          <center>
            <a className="waves-effect waves-light btn modal-trigger" href={'#irrigation-log-prepare'}
              onClick={() => this.props.prepareData({
                user: this.props.user,
                engineLog: this.props.app.engineLog,
                meterLog: this.props.app.meterLog,
                valveLog: this.props.app.valveLog,
                formData: packageForm('irrigation-form')
              })}>
              Prepare
            </a>
          </center>
          {
            FooterModal(IrrigationDisplay)
            // eslint-disable-next-line
            ({
              id: 'irrigation-log-prepare',
              employees: this.props.employees,
              engines: this.props.engines,
              meters: this.props.meters,
              valves: this.props.valves,
              app: this.props.app,
              view: false,
              footer: true,
              onClick: () => this.props.createIrrigation({ app: this.props.app, employees: this.props.employees, formId: 'irrigation-form' })
            })
          }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    app: state.irrigation.create.app,
    employees: state.irrigation.utils.employees,
    engines: state.irrigation.utils.engines,
    meters: state.irrigation.utils.meters,
    prevMeters: state.irrigation.create.prevMeters,
    user: state.auth.user,
    valves: state.irrigation.utils.valves
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createIrrigation,
    handleEngineHours,
    handleMeterGallons,
    handleValveHours,
    preloadMeterForm,
    prepareData
  }, dispatch);
}

IrrigationCreate.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(IrrigationCreate);



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/irrigation_create.js